// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"563":"f76b1cdde46f6e87","4896":"84f6640a228a67d3","5259":"fc301960a33d88b1","6572":"caa3919a5018ea11","7282":"458153f1179bd02f","8199":"f01407468f07465e"}[chunkId] + ".css";
};